import React, { useState, useEffect, useCallback , useRef,memo } from "react";
import {
  APIProvider,
  Map,
  useMap,
  useMapsLibrary,
} from "@vis.gl/react-google-maps";
import {
  Box,
  TextField,
  Typography,
  Button,
  Card,
  CardContent,
  Grid,
} from "@mui/material";
import { LocationOn } from "@mui/icons-material";
import _ from "lodash";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useNavigate } from 'react-router-dom';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { showLoader, hideLoader } from "Redux/Loader/actions";
//services
import { API_ENDPOINTS } from "../../Constants"; // <-- replace with your actual API key config
import useStyles from "./style";
import DispatcherApi from "Services/Dispatcher";

// components 

import BookingForm from "./Bookingform"

const DashboardHotelPage = () => {
  const timezone = useSelector((state) => {
    const selectedTimezone = state?.timezone?.timezone || 'America/Anchorage';
    return selectedTimezone === "Asia/Coimbatore" ? "Asia/Kolkata" : selectedTimezone;
  });
  const systemlatitude = useSelector((state) => Number(state?.timezone?.latitude) || 11.127123);
  const systemlongitude = useSelector((state) => Number(state?.timezone?.longitude) || 78.656891);  
  const classes = useStyles();
  const dispatch = useDispatch();
 const [services, setservices] = useState([]);
  const [allDrivers, setalldrivers] = useState([]);  
  //map things 
  const [origin, setOrigin] = useState("");
  const [destination, setDestination] = useState("");
  const [mapCenter, setMapCenter] = useState({ lat: systemlatitude , lng: systemlongitude });
  const mapRef = useRef(null);
  const navigate = useNavigate();
  const userType = useSelector(
    (state) => state?.AuthReducer?.userType || ""
  );

   const getservicesanddrivers = useCallback(() => {
  dispatch(showLoader("Loading please wait..."));
  const onSuccess = (res) => {
    dispatch(hideLoader());
    //console.log("fetched user request data--->",res?.data);
    if (res?.data?.status === true) {
      //console.log("fetched active service data--->",res?.data?.data?.serviceTypeDetails)
      //console.log("fetched available drivers data--->",res?.data?.data?.driverInfoDetails)
      setservices(res?.data?.data?.serviceTypeDetails);
      setalldrivers(res?.data?.data?.driverInfoDetails);
    } else {
      setalldrivers([]);
    }
  };
  const onFailure = (err) => {
    dispatch(hideLoader());
    dispatch(
      showSnackbar({
        message: err?.response?.data?.message || "Failed to fetch data",
        autoHideDuration: 3000,
        anchorOrigin: {
          vertical: "top",
          horizontal: "right",
        },
        variant: "error",
      })
    );
    //console.log("Get member / partner details Api", err);
  };
  DispatcherApi.getdriversandservices().then(onSuccess, onFailure);
}, []);

  useEffect(() => {
    if (mapRef.current) {
      mapRef.current.panTo({ lat: systemlatitude, lng: systemlongitude });
    } else {
      setMapCenter({ lat: systemlatitude, lng: systemlongitude });
    }
    getservicesanddrivers();
  }, [systemlatitude, systemlongitude]);   

const libraries = ["places", "drawing" , 'routes'];

// Direction rendering component 
const Directions = memo(({ origin, destination }) => {
const map = useMap();
const routesLibrary = useMapsLibrary("routes");
const [directionsRenderer, setDirectionsRenderer] = useState(null);

useEffect(() => {
if (!origin || !destination) return;

if (!directionsRenderer) {
  const newDirectionsRenderer = new routesLibrary.DirectionsRenderer({ map });
  setDirectionsRenderer(newDirectionsRenderer);
}

const directionsService = new routesLibrary.DirectionsService();

directionsService.route({
    origin,
    destination,
    travelMode: "DRIVING",
  })
  .then((response) => {
    directionsRenderer?.setDirections(response);
  })
  .catch((error) => console.error("Error fetching directions:", error));

return () => {
  directionsRenderer?.setMap(null);
};
}, [origin, destination, map, routesLibrary, directionsRenderer]);

return null;
});

  return (
    <>
<Grid container className={classes.mapcontainer} >
<Grid item xs={12} >

<APIProvider 
apiKey={API_ENDPOINTS.GMAP_API} // Use your actual API key
libraries={libraries}
>
<React.Fragment >

      <Grid container sx={{ height: "80vh" }}>
        {/* Left Side Booking Form */}
{/* booking form */}

 <BookingForm 
 userType={userType}
 setOrigin={setOrigin}
 setDestination={setDestination}
 origin={origin} destination={destination}
 setMapCenter={setMapCenter}
 services={services}
 timezone={timezone}
 />         

        {/* Right Side Map */}
        <Grid item xs={12} md={8}>
         <Map
  style={{
    width: "100%",
    height: "80vh",   // full screen height
  }}
defaultCenter={mapCenter}
defaultZoom={10}
gestureHandling={"greedy"}
mapId={"40e581fce79a8421a2f62ee2"}
 onLoad={(map) => (mapRef.current = map)}
>
<Directions origin={origin} destination={destination} />
          </Map>
        </Grid>

      </Grid>

</React.Fragment>      
    </APIProvider>

</Grid>
</Grid>    
</>
  );
};

export default DashboardHotelPage;
